import React from "react"
import Tabs from "../Tabs/Tabs"
import DynamicRatesDashboardTabContent from "./DynamicRatesDashboardTabContent"

class DynamicRatesDashboard extends React.Component {
  constructor(props) {
    super(props) 
      this.state = {
        active_tab: "dynamic_rates_pace",
      }
      this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
  }

  render() {
    return(
      <div className="folio-items-dashboard">
        <div className="panel panel-form">
          <Tabs tabs={this.tabs()} displayErrorMessage={false} />
          <DynamicRatesDashboardTabContent {...this.state} 
            dynamic_rates_pace_data_table_path={this.props.dynamic_rates_pace_data_table_path}
            dynamic_rates_occupancy_data_table_path={this.props.dynamic_rates_occupancy_data_table_path}
            date_format={this.props.date_format}
            time_format={this.props.time_format} 
            export_csv_endpoint={this.props.export_csv_endpoint}  
          />
        </div>
      </div>
    )
  }
  

  tabs() {
    return (
      [
        {
          tabName: I18n.t('pace'),
          targetName: 'dynamic_rates_pace',
          classes: this.state.active_tab === 'dynamic_rates_pace' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          // tabErrorCount: RateBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('occupancy'),
          targetName: 'dynamic_rates_occupancy',
          classes: this.state.active_tab === 'dynamic_rates_occupancy' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          // tabErrorCount: RateBuilderErrors.billing_policy(this.state.errors).length
        },
      ]
    );
  };

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  }
}

export default DynamicRatesDashboard